<template>
    <MainContent title="Información Precio Parcela">
        <template v-slot:header>
            <h3 class="card-title mb-3">Información del Precio de Parcela</h3>
        </template>
        
        <template v-slot:content>
            <div v-if="loading" class="text-center p-5">
                <b-spinner 
                    variant="primary" 
                    label="Cargando..." 
                />
            </div>
            
            <b-row v-else-if="parcela">
                <b-col cols="12">
                    <ContainerTable :data="[parcela]" :responsive="esMovil">
                        <b-table 
                            hover 
                            :items="[parcela]" 
                            :fields="fields" 
                            empty-text="No se ha encontrado la información del precio de esta parcela"
                        >
                            <template #cell(precio)="{ item }">
                                {{ item.precio }}€
                            </template>
                            
                            <template #cell(start_date)="{ item }">
                                {{ item.start_date }}
                            </template>
                            
                            <template #cell(end_date)="{ item }">
                                {{ item.end_date }}
                            </template>
                            
                            <template #cell(price_management_online)="{ item }">
                                {{ item.price_management_online }}€ 
                            </template>

                            <template #cell(price_management_online_interno)="{ item }">
                                {{ item.price_management_online_interno  }}
                            </template>
                            
                            <template #cell(price_management_taquilla)="{ item }">
                                {{ item.price_management_taquilla }}€ 
                            </template>
                            
                            <template #cell(price_management_taquilla_interno)="{ item }">
                                {{ item.price_management_taquilla_interno }}
                            </template>
                        </b-table>
                    </ContainerTable>
                </b-col>
            </b-row>
            
            <div v-else class="text-center">
                No se ha encontrado la información del precio de parcela.
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContainerTable from '@/components/backend/common/ContainerTable';

    export default {
        props: {
            precio_id:{
                type: [String, Number],
                required: true
            },
            lista_id:{
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                parcela: null,
                loading: true,
                fields: [
                    { key: "id", label: "ID" },
                    { key: "description", label: "Descripción" },
                    { key: "precio", label: "Precio", class: "text-center" },
                    { key: "start_date", label: "Fecha inicio", class: "text-center" },
                    { key: "end_date", label: "Fecha fin", class: "text-center" },
                    { key: "price_management_online", label: "Gastos gestión online", class: "text-center" },
                    { key: "price_management_online_interno", label: "Gastos gestión online interno", class: "text-center" },
                    { key: "price_management_taquilla", label: "Gastos gestión taquilla", class: "text-center" },
                    { key: "price_management_taquilla_interno", label: "Gastos gestión taquilla interno", class: "text-center" },
                ]
            }
        },
        created() {
            this.getParcela();
        },
        methods: {
            async getParcela() {
                try {
                    this.loading = true;
                    const params = {
                        lista_id: this.lista_id,
                        precio_id: this.precio_id
                    };
                    
                    const response = await this.$store.dispatch('BACK_PRECIOS_PARCELAS_VER', params);
                    this.parcela = response.data.data;
                } catch (error) {
                    this.$toast.error('Error al cargar los datos de la parcela: ' + error.message);
                } finally {
                    this.loading = false;
                }
            },
        },
        components: {
            MainContent,
            ContainerTable,
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        }
    }
</script>